// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"63b9bc68","199":"c1b9d148","211":"c1b9d148","350":"c1b9d148","436":"c1b9d148"}[chunkId] + ".chunk.css";
};